import React, { useEffect, useState } from "react"; import { Field, FormikProvider, Form, useFormik } from "formik"; import Menubar from "../Menubar"; import { store } from "../../App"; import { IoIosReturnLeft } from "react-icons/io"; import MasterService from "../../Services/MasterService"; import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai"; import { Container, Row, Col, Nav, Table,Button, Modal } from 'react-bootstrap';
import { MdOutlinePictureAsPdf } from "react-icons/md";import Select from 'react-select'; import "jspdf-autotable"; import { commonSelectProps, currentDate, datetime, exportToExcel, formatNumberIndianWithDecimal, generatelargePdf, generatePdf } from "../utils/commonFunctions"; import AlertModal from "../Alert/AlertModal"; import useAlert from "../Alert/useAlert"; import KpiService from "../../Services/KpiService";
export default function ProgressRreportKn() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert(); const [uniqueDistricts, setuniqueDistricts] = useState(); const [years, setyears] = useState(); const [categorys, setcategorys] = useState(); const [selectedperiodicity, setselectedperiodicity] = useState(); const [selectedyear, setselectedyear] = useState(); const [selectedcategory, setselectedcategory] = useState(); const [distlist, setDistrictList] = useState(); const [Periodicitylist, setPeriodicitylist] = useState(); const [Yearlist, setYearlist] = useState(); const [Categorylist, setCategorylist] = useState(); const [searchText, setSearch] = useState(""); const [searchText1, setSearch1] = useState(""); const [Id, setId] = useState(); const [Periodicid, setperiodicId] = useState(); const [dists, setDists] = useState(); const [distEnb, setDistEnb] = useState(false); const [EntryData, setEntrydata] = useState(); const [entrydataEnb, setEntrydataEnb] = useState(false); const [CpoTableenb, setCpoTableenb] = useState(false); const [Asotableenb, setAsotableenb] = useState(false); const [Cpodata, setCpodata] = useState([]); const [Deptlist, setDeptlist] = useState([]); const [Distname, setDistname] = useState(); const [Deptname, setDeptname] = useState();
  let username = localStorage.getItem("username"); let roleid = localStorage.getItem("catid"); let district = localStorage.getItem("districtid"); let deptId = localStorage.getItem("deptid"); let SectariatName = localStorage.getItem("SectariatcodeName"); let deptName = localStorage.getItem("deptName");
   const [monthList,setMonthList] = useState([]);
 const[pendingData,setPendingData]=useState();
 const[pendingIndData,setPendingIndData]=useState()
  const formik = useFormik({
   initialValues: {
      year: "",month:"",department_id:"",district_id:""
    },
    
    // { userId: "", district_id: "", mandal_id: "", department_id: "", periodic_id: "", year: "", date: "", month:"",Indicators: [{ indicator_id: "", entry_value: "" }], remarks: "" },
    onSubmit: (values) => {
    }
  })
  const[addModal,setAddmodal]=useState()
  // const handleClose=()=>{
  //   setAddmodal(false)
  // }
  React.useEffect(() => {
    if ((roleid === "111") || (roleid === "117") || (roleid === "113")) { setDistEnb(true) }
    if (roleid === "116") { setDistEnb(false) }
    if (roleid === "113" || roleid === "119") { setDistEnb(true) }
    if (roleid !== "116") {
    formik.setFieldValue("district_id", district)
    }
  }, [])
  const [Depts, setDepts] = useState();
  const headerStyle = { backgroundColor: "#4e835c", color: "white", padding: "5px", border: "1px solid white" };

  useEffect(() => {
    MasterService.getDistricts().then((res17) => {
      if (res17.data) { setDists([ { id: "0", value: "All" }, ...res17.data ]);
        let options = res17.data.map((item, i) => { return (<option key={i} value={item.id}> {item.value} </option>); });
        setDistrictList(options); } });
    let params = { userId: username }
   if (["116", "119", "117"].includes(roleid)) {
      MasterService.getAllDepts(params).then((res) => { const list = res?.data?.SDESC ?? [];
      const updatedList = [ { dept_id: 0, dept_name: "All" }, ...list ];
      setDepts(updatedList); })} 
    
       MasterService.getkpiMonths(params).then((finachievres) => {
      if (finachievres.data) {
        
           setMonthList(finachievres.data.SDESC);
        }
      });

         MasterService.getfinyears().then((finachievres) => {
      if (finachievres.data) {
         let options = finachievres.data.map((item, i) => {
            return ( <option key={i} value={item.id}> {item.value} </option> );
          });
           setyears(finachievres.data);
        }
      });
    }, []);


 const getData = (monthh) => {
    if (!monthh) { showAlertMessage("Year Required", "error"); setEntrydata([]); return; }
    let params = { userId: username, year:formik.values.year, monthOrder:monthh, deptId:["113","111","117"].includes(roleid)?deptId:formik.values.department_id, districtId:["113","119","111","117"].includes(roleid)? district:formik.values.district_id };
   store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.districtkpisprogressReport(params).then((res) => {
      store.dispatch({ type: "HIDE_SPINNER" });
      setPendingData([])
      if (res.data.SCODE === "02") {
        showAlertMessage(res.data.SDESC, "warning"); setEntrydata([]);
        setEntrydataEnb(false); setAsotableenb(false); setCpoTableenb(false);
      }
      else {
        if (res.data.SCODE === "01") {
          setEntrydataEnb(true); let enb = false; setCpoTableenb(false);
          setAsotableenb(true); setEntrydata(res.data.districtkpisprogressReport);
        }
        else { showAlertMessage(res.data.SDESC, "warning");
          setEntrydata([]); setEntrydataEnb(false); setCpoTableenb(false); setAsotableenb(true);
        } } }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); }); };



  const filteredData = searchText.length > 0 && Cpodata?.length
    ? Cpodata.filter((item) => {
      return (item && Object.keys(item).some((key) => {
        const value = item[key]; return (value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase()));
      })); }) : Cpodata;
  const filteredDistricts = uniqueDistricts?.filter((district) =>
    filteredData?.some((item) => item.district_name === district)
  );
  const filteredData1 = searchText1.length > 0 && EntryData?.length
    ? EntryData.filter((item) => {
      return (item && Object.keys(item).some((key) => {
        const value = item[key];
        return (value !== null && value.toString().toLowerCase().includes(searchText1.toLowerCase()));
      })); }) : EntryData;
  const BackFunct = () => { setSearch(""); setAsotableenb(true);setCpoTableenb(false); setPendingData([]);setCpodata([]) }
  const [currentdate, setcurrentdate] = useState(''); const [currenttime, setcurrenttime] = useState('');
  useEffect(() => { datetime(setcurrentdate, setcurrenttime); }, []);
  const [showReportModal, setShowReportModal] = useState(false);
const[viewType,setViewtype]=useState("")
const handleClose = () => {setShowReportModal(false);setPendingData([]);setCpodata([])}
const handleShow = () => setShowReportModal(true);
  const Pendingcount=(row,type)=>{
    setViewtype(type)
    setShowReportModal(true)
setCpoTableenb(true)
    store.dispatch({ type: "SHOW_SPINNER" });

 const params = {
          userId: username, 
          districtId: ["113","119","111","117"].includes(roleid)? district:formik.values.district_id  ,
          
    "monthOrder": formik.values.month,
          
           year: formik.values.year,
          deptId: row.dept_id,"type":type,
      }; 
         KpiService.districtkpisprogressReportpendinglist(params).then((res) => {
      store.dispatch({ type: "HIDE_SPINNER" });
        if (res.data.SCODE === "01") {
          setEntrydataEnb(true);  setCpoTableenb(true);
          // setAsotableenb(false);
           setCpodata(res.data.districtkpisprogressReport);
        
        }
         else {
          setCpodata([]); setEntrydataEnb(false); setCpoTableenb(false); setAsotableenb(true);
         }
      })
  }



  const Pendinglist=(row)=>{
setCpoTableenb(true)
    store.dispatch({ type: "SHOW_SPINNER" });

 const params = {
          userId: username, 
                   districtId: ["113","119","111","117"].includes(roleid)? district:formik.values.district_id  ,

           year: formik.values.year,
          deptId: row.dept_id,"type":"mandalspendingList",indicator_id:row.indicator_id,monthOrder: formik.values.month
      }; 
         KpiService.districtkpisprogressReportpendinglist(params).then((res) => {
      store.dispatch({ type: "HIDE_SPINNER" });
        if (res.data.SCODE === "01") {
          setEntrydataEnb(true);  setCpoTableenb(true);
          // setAsotableenb(false);
           setPendingData(res.data.districtkpisprogressReport);
        
        }
         else {
          setPendingData([]);  setCpoTableenb(true)
         }
      })
  }
 

  return (
    <>
      <Menubar />
      <Container fluid className='map-header1'  > <div className='sa-title'> <h2>District Kpis <span>Progress Report</span></h2> </div> </Container>
      <Container fluid style={{ width: "87%" }} className="outer-page-content-container mt-3">
        <FormikProvider value={formik} >
          <Form onSubmit={formik.handleSubmit}>
            <div className='mandal-container p-4'>
        
                   
                    <Row>
                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
                  <label htmlFor="department_id" className="mb-1 fw-bold"> HOD Name </label>
                 {["116", "119", "117"].includes(roleid) ? (    <Select {...commonSelectProps({ name: "department_id", options: Depts, value: formik.values.department_id, optionValueKey: "dept_id", optionLabelKey: "dept_name", formik, 
                    isDisabled: ["111", "113", "114"].includes(roleid),
                     extraOnChange: (option) => {setAsotableenb(false); formik.setFieldValue("year",""); formik.setFieldValue("month","");
                       if (roleid !== "119") {
    formik.setFieldValue("district_id", "");
  }
                      ; setEntrydata([]);

                    
                    } })} />
                      ) : (<Field className="mb-3 form-control" type="text" name="department_id"
                      value={localStorage.getItem("deptcodeName")} controlId="formBasicEmail" disabled={true} style={{ fontWeight: "bold" }} />)} </Col>
                
                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select">
                  <label className="mb-1 fw-bold"> District </label> <span style={{ color: "red" }}> *</span>
                  <Select {...commonSelectProps({ name: "district_id", options: dists, value: formik.values.district_id, optionValueKey: "id", optionLabelKey: "value", formik, 
                  isDisabled: ["113","119","111","117"].includes(roleid),
                    extraOnChange: (option) => {  formik.setFieldValue("year",""); formik.setFieldValue("month","");setEntrydata([]);setAsotableenb(false)} })} />
                 
                </Col>

                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3}>
                                                     <label className="mb-1 fw-bold"> Financial Year </label> <span style={{ color: "red" }}> *</span>
                                                    <Select
  {...commonSelectProps({
    name: "year",
    options: years,
    value: formik.values.year,
    optionValueKey: "id",
    optionLabelKey: "value",
    formik,
    isDisabled: false,

    extraOnChange: (option) => {
formik.setFieldValue("month",""); setAsotableenb(false);setEntrydata([]);
    }
  })}
/>   
                                                   </Col>

                                                   <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3}>
                                                     <label className="mb-1 fw-bold"> Month</label> <span style={{ color: "red" }}> *</span>
                                                    <Select
  {...commonSelectProps({
    name: "month",
    options: monthList,
    value: formik.values.month,
    optionValueKey: "month_order",
    optionLabelKey: "month_name",
    formik,
    isDisabled: false,

    extraOnChange: (option) => {
getData(option?option.month_order:"");
    }
  })}
/>   
                                                   </Col>
              </Row>
                   
                   
                    </div> <br />
                    {Asotableenb && <> <Row> <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
            <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container"><AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} />
              <input type="text" placeholder="Search" value={searchText1} onChange={(e) => setSearch1(e.target.value)} 
              onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} />
            </div> </Col>
          <Col className="mb-2">
           <button  onClick={() => generatePdf("#my-table", "DistrictLevelIndicatorProgressReport", 14)} className="btn btn-danger btn-sm mx-2 pdf-btn"
           style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
           <button className="btn mx-2 excel-btn" size="sm" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} 
           onClick={() => exportToExcel("my-table", "DistrictLevelIndicatorProgressReport")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
          </Col> </Row>
        <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-1"> <span className="style"> Key Performance Indicators Progress report</span>
                <br/>  <span className="style-1"> HOD Name:</span> <span className="style-2">{formik.values.department_id === "0" ? "ALL" :  Depts?.find( (d) => d.dept_id === formik.values.department_id )?.dept_name || ""  }</span>
                  <span className="style-1">District:</span>
<span className="style-2"> { dists?.find( (d) => d.id === formik.values.district_id )?.value || "" } </span>
                  <span className="style-1">Financial Year</span> <span className="style-2">{formik.values.year}</span>
                  <span className="style-1">Month:</span> 
<span className="style-2"> { monthList?.find( (d) => d.month_order === formik.values.month )?.month_name || "" } </span>
                  
         <div className="text-end style-1"> Report On : {currentdate} {currenttime} </div> </div>
        <div id="table-scroll" className="table-scroll"> <div className="table-wrap">
            <Table bordered id="my-table" className="custom-table table-responsive  table table-bordered sticky-table">
 <thead> <tr className="text-center only-export"> 
    <th colSpan={14} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}> Key Performance Indicators Progress report </th> 
   
          <br/>  <spa        n className="style-1"> HOD Name:</spa> <span className="style-2">{formik.values.department_id === "0" ? "ALL" :  Depts?.find( (d) => d.dept_id === formik.values.department_id )?.dept_name || ""  }</span>
                  <span className="style-1">District:</span>
<span className="style-2"> { dists?.find( (d) => d.id === formik.values.district_id )?.value || "" } </span>
                  <span className="style-1">Financial Year</span> <span className="style-2">{formik.values.year}</span>
                  <span className="style-1">Month:</span> 
<span className="style-2"> { monthList?.find( (d) => d.month_order === formik.values.month )?.month_name || "" } </span>
                  </tr>
    <tr className="text-center">
       <th style={headerStyle} className="sticky-col sticky-sno" rowSpan={2}>Sl.No.</th> 
    <th className="sticky-col sticky-KPIHOD indicator-column" style={headerStyle} rowSpan={2} >Department Name</th>
    {/* {formik.values.district_id === "0" &&<th className="" style={headerStyle} rowSpan={2} >District</th>} */}
     <th style={headerStyle} colSpan={3}>Total no.of Indicators </th> 
     <th style={headerStyle} colSpan={3}>Total no.of Targets </th> 
     <th style={headerStyle} colSpan={3}> No.of Indicators entry completed</th> 
     <th style={headerStyle} colSpan={3}>No.of Indicators entry pending </th>
      {/* <th style={headerStyle} colSpan={2}>Pending indicators for approval </th> */}
       </tr> <tr> {Array.from({ length: 12 }).map((_, i) => ( <th key={i} style={headerStyle}> {i % 3 === 0 ? "District" : i % 3 === 1 ? "Mandal" : "Total"} </th> ))} </tr>
</thead>
<tbody>
  {filteredData1?.length === 0 || filteredData1 === undefined ? (
    <tr> <td colSpan={14} className="text-center">
        <b style={{ color: "red" }}>Details Not Found</b>
      </td> </tr> ) : (
    filteredData1.map((row, index) => ( <tr key={row.dept_id}>
        <td className="text-center sticky-col sticky-sno"> {index + 1} </td>
        <td className="sticky-col sticky-KPIHOD indicator-column"> {row.dept_name} </td>
        {/* {formik.values.district_id === "0" &&<td > {row.district_name} </td>} */}

        <td style={{textAlign:"right"}}> {row.district_ind_tot_count} </td>
        <td style={{textAlign:"right"}}> {row.mandal_ind_tot_count} </td>
        <td style={{textAlign:"right"}}> {row.ind_tot_count} </td>
        <td style={{textAlign:"right"}}>{row.dist_tot_tr_ind_count}</td>
        <td style={{textAlign:"right"}}>{row.mand_tot_tr_ind_count}</td>
        <td style={{textAlign:"right"}}>{row.dm_total_targets}</td>
        <td style={{textAlign:"right"}}>{row.dist_ind_ac_tot_count}</td>
        <td style={{textAlign:"right"}}>{row.mand_ind_ac_tot_count}</td>
        <td style={{textAlign:"right"}}>{row.dm_total_ac}</td>
               <td  
  onClick={() => row.dist_tot_ac_pend_count !== 0 && Pendingcount(row,"districtpendingCount")}
          style={ row.dist_tot_ac_pend_count !== 0 ? { textAlign: "right", verticalAlign: "middle", color: "blue", cursor: "pointer", } : { textAlign: "right", verticalAlign: "middle", } }
        >  
          
          {row.dist_tot_ac_pend_count}</td>
        <td  
  onClick={() => row.mand_tot_ac_pend_count !== 0 && Pendingcount(row,"mandalpendingCount")}
          style={
    row.mand_tot_ac_pend_count !== 0
      ? {
          textAlign: "right",
          verticalAlign: "middle",
          color: "blue",
          cursor: "pointer",
        }
      : {
          textAlign: "right",
          verticalAlign: "middle",
        }
  }
        
        >{row.mand_tot_ac_pend_count}</td>
        {/* <td  onClick={()=>Pendingcount(row)} style={{ textAlign: "right", verticalAlign: "middle", color: "blue", cursor: "pointer" }}>{row.dm_ac_tot_pend}</td> */}
        <td
        style={{textAlign:"right"}}

>
  {row.dm_ac_tot_pend}
</td>
        {/* <td   onClick={()=>PendingcountDist(row)} style={{ textAlign: "right", verticalAlign: "middle", color: "blue", cursor: "pointer" }}>{row.district_pending_approval}</td> */}
        {/* <td   onClick={()=>PendingcountMandal(row)} style={{ textAlign: "right", verticalAlign: "middle", color: "blue", cursor: "pointer" }}>{row.mandal_pending_approval}</td> */}
      </tr> )) )} </tbody>
            </Table> </div> </div> </>} 
                     
<Modal
  show={showReportModal}
  onHide={handleClose}
  size="xl"
  centered
  backdrop="static"
  dialogClassName="custom-modal-width"
>
   { viewType!="districtpendingCount" &&
  <style>
    {`
      .custom-modal-width {
        max-width: 80vw !important;
        width: 80vw !important;
      }
    `}
  </style>
} 
  <Modal.Header closeButton>
    <Modal.Title>Key Performance Indicators Progress Report</Modal.Title>
  </Modal.Header>

  <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>

    {CpoTableenb && (
      <>
        {/* 🔍 SEARCH */}
        <Row className="mt-3">
          <Col md={3} className="mb-3">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #ddd",
                borderRadius: "20px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                backgroundColor: "#fff",
                padding: "5px 10px",
              }}
            >
              <AiOutlineSearch className="me-2" style={{ color: "#888" }} />
              <input
                type="text"
                placeholder="Search"
                value={searchText}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  flex: 1,
                  border: "none",
                  outline: "none",
                  background: "transparent",
                }}
              />
            </div>
          </Col>
        </Row>

        {/* 📊 TABLES */}
        <Row>

          {/* LEFT TABLE */}
        <Col
  xl={viewType === "districtpendingCount" ? 12 : 6}
  style={{ display: "flex" }}
>
            <div className="w-100 d-flex flex-column" style={{ height: "500px" }}>
              
              <div className="text-center border rounded-1 py-1" style={{ backgroundColor: "#d4e3d8" }}>
                <span className="style">KPI Progress Report</span>
                <div className="text-end style-1">
                  {currentdate} {currenttime}
                </div>
              </div>

              <div style={{ flex: 1, overflowY: "auto" }}>
                <Table bordered className="custom-table sticky-table">
                  <thead>
                    <tr className="text-center">
                      <th style={headerStyle}>Sl.No.</th>
                      <th style={headerStyle}>Indicators Pending</th>
                      <th style={headerStyle}>Level</th>
                     { viewType !== "districtpendingCount" && 
                     <>
                      <th style={headerStyle}>Completed</th>
                      <th style={headerStyle}>Pending</th>
                      </>}
                    </tr>
                  </thead>

                  <tbody>
                    {!filteredData?.length ? (
                      <tr>
                        <td colSpan={5} className="text-center text-danger">
                          Details Not Found
                        </td>
                      </tr>
                    ) : (
                      filteredData.map((row, index) => (
                        <tr key={row.dept_id}>
                          <td className="text-center">{index + 1}</td>
                          <td>{row.indicator_name}</td>
                          <td>{row.entry_level}</td>
                          { viewType !== "districtpendingCount" && <>        
                                          <td className="text-end">{row.ac_completed}</td>
                          <td
                            onClick={() => Pendinglist(row)}
                            style={{
                              textAlign: "right",
                              color: row.ac_pending ? "blue" : "inherit",
                              cursor: row.ac_pending ? "pointer" : "default",
                            }}
                          >
                            {row.ac_pending}
                          </td>
                          </>}
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </Col>

          {/* RIGHT TABLE */}
        { viewType!="districtpendingCount" && (
          <Col xl={6} style={{ display: "flex" }}>
            <div className="w-100 d-flex flex-column" style={{ height: "500px" }}>
              
              <div className="text-center border rounded-1 py-1" style={{ backgroundColor: "#d4e3d8" }}>
                <span className="style">Pending Mandals</span>
                <div className="text-end style-1">
                  {currentdate} {currenttime}
                </div>
              </div>

              <div style={{ flex: 1, overflowY: "auto" }}>
                <Table bordered className="custom-table sticky-table">
                  <thead>
                    <tr className="text-center">
                      <th style={headerStyle}>Sl.No.</th>
                      <th style={headerStyle}>Mandal Name</th>
                    </tr>
                  </thead>

                  <tbody>
                    {!pendingData?.length ? (
                      <tr>
                        <td colSpan={2} className="text-center text-danger">
                          Details Not Found
                        </td>
                      </tr>
                    ) : (
                      pendingData.map((row, index) => (
                        <tr key={index}>
                          <td className="text-center">{index + 1}</td>
                          <td>{row.mandal_name}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </Col>
        )}
        </Row>
      </>
    )}

  </Modal.Body>

  
</Modal>
          
        
         

            {/* <Modal className="newmodal" fade={false} size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={addModal}>
                            <Modal.Header style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                              <Modal.Title className="text-center  fw-bold " style={{ margin: "0 auto", color: "black", fontFamily: "'Times New Roman', Times, serif" }}>  {viewType === "district"?"Districts Pending Indicators":"Mandals Pending Indicators"}  </Modal.Title>
                              <button type="button" tabIndex={0} onClick={handleClose} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleClose(); } }} style={{ fontSize: "29px", cursor: "pointer", color: "black" }} onMouseEnter={(e) => (e.currentTarget.style.color = "red")} onMouseLeave={(e) => (e.currentTarget.style.color = "black")} > &#215; </button>
                            </Modal.Header>
                            <Modal.Body className="p-3">

           <Table bordered id="my-table" className="custom-table table-responsive  table table-bordered sticky-table">
        
           <thead>
                <tr className="text-center only-export"> <th colSpan={14} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}> Key Performance Indicators Progress report </th> </tr>

<tr style={{ textAlign: "center" }}>
  <th style={headerStyle} className="sticky-col sticky-sno">Sl.No.</th>

  {viewType === "district" && (
    <th style={headerStyle}>District Name</th>
  )}

  {viewType === "mandal" && (
    <th style={headerStyle}>Mandal Name</th>
  )}
</tr>


</thead>
<tbody>
  {pendingIndData?.length === 0 || pendingIndData === undefined ? (
    <tr>
      <td colSpan={14} className="text-center">
        <b style={{ color: "red" }}>Details Not Found</b>
      </td>
    </tr>
  ) : (
    pendingIndData.map((row, index) => (
      <tr key={row.dept_id}>
        <td className="text-center sticky-col sticky-sno">
          {index + 1}
        </td> {viewType === "district" && (
        <td>{row.district_name}</td>)}
 {viewType === "mandal" && (
  <td>{row.mandal_name}</td>)}
      </tr>
    ))
  )}
</tbody>



            </Table>
                            </Modal.Body>
                            </Modal> */}
          </Form> </FormikProvider> </Container>
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>);
}






